/* ============================================================
   CHIANG KONG — live store status
   Region-aware top bar + workshop badges.
   Open / On lunch / Closing soon / Closed, computed in UTC+8
   (Singapore & Malaysia share the same timezone).

   Reads its data from window.CK_BRANCHES which Liquid injects from
   the `branch` metaobjects. Falls back to a hardcoded list so the
   site still works if the metaobjects haven't been seeded.
   ============================================================ */
(function () {
  'use strict';

  /* ---- Hardcoded fallback (used only if window.CK_BRANCHES is empty) ---- */
  var FALLBACK_WEEKLY = {
    mon: { open: 540, close: 1080, lunch: [780, 840] },
    tue: { open: 540, close: 1080, lunch: [780, 840] },
    wed: { open: 540, close: 1080, lunch: [780, 840] },
    thu: { open: 540, close: 1080, lunch: [780, 840] },
    fri: { open: 540, close: 1080, lunch: [780, 840] },
    sat: { open: 540, close: 1080, lunch: [780, 840] },
    sun: null,
  };
  var FALLBACK_HOURS = ckT('ui.store.fallback_hours', 'Mon–Sat · 9:00–18:00');
  var FALLBACK = [
    { id: 'tannery', name: 'Tannery Lane', city: 'Singapore', country: 'sg', main: true,
      hours: FALLBACK_HOURS, tel: '+65 9100 2680',
      weekly: FALLBACK_WEEKLY, ph: null, href: '/pages/workshops#sg' },
    { id: 'cheras', name: 'Cheras', city: 'Kuala Lumpur', country: 'my', main: true,
      hours: FALLBACK_HOURS, tel: '+60 16-692 3440',
      weekly: FALLBACK_WEEKLY, ph: null, href: '/pages/workshops#my' },
    { id: 'sunway', name: 'Bandar Sunway', city: 'Subang Jaya', country: 'my', main: false,
      hours: FALLBACK_HOURS, tel: '+60 10-217 8828',
      weekly: FALLBACK_WEEKLY, ph: null, href: '/pages/workshops#my' },
    { id: 'jb', name: 'Johor Bahru', city: 'Johor', country: 'my', main: false,
      hours: FALLBACK_HOURS, tel: '+60 16-217 8893',
      weekly: FALLBACK_WEEKLY, ph: null, href: '/pages/workshops#my' },
  ];

  var STORES = (window.CK_BRANCHES && window.CK_BRANCHES.length > 0)
    ? window.CK_BRANCHES
    : FALLBACK;
  window.CK_STORES = STORES;

  var DAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  var DAY_LABEL = [
    ckT('ui.days.sun', 'Sun'), ckT('ui.days.mon', 'Mon'), ckT('ui.days.tue', 'Tue'),
    ckT('ui.days.wed', 'Wed'), ckT('ui.days.thu', 'Thu'), ckT('ui.days.fri', 'Fri'),
    ckT('ui.days.sat', 'Sat')
  ];

  /* Locale-aware internal path: under /zh-cn/ a bare /pages/... would drop the
     visitor back to English. Leaves external / already-prefixed paths alone. */
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function localPath(p) {
    if (!p || p.charAt(0) !== '/' || p.charAt(1) === '/' || ROOT === '/') return p;
    if (p.indexOf(ROOT) === 0 || p + '/' === ROOT) return p;
    return ROOT + p.slice(1);
  }

  function nowUTC8() {
    var d = new Date();
    return new Date(d.getTime() + d.getTimezoneOffset() * 60000 + 8 * 3600000);
  }

  function fmt(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    var hh = h % 12;
    if (hh === 0) hh = 12;
    var vars = { h: hh, m: (m < 10 ? '0' + m : m) };
    return h >= 12
      ? ckT('ui.store.time_pm', '{h}:{m} PM', vars)
      : ckT('ui.store.time_am', '{h}:{m} AM', vars);
  }

  /** Returns the hours entry for a day on a given store: {open, close, lunch?} or null.
   *  I2 2026-07-02: theme.liquid now emits weekly/ph as JSON strings (| json) to defend
   *  against malformed metaobject fields SyntaxErroring the inline script. Parse here. */
  function dayEntryFor(store, dayIndex) {
    var w = store.weekly;
    if (typeof w === 'string') { try { w = JSON.parse(w); } catch (e) { w = null; } }
    if (!w) return null;
    var key = DAY_KEYS[dayIndex];
    var entry = w[key];
    if (entry == null) return null;
    return entry;
  }

  function statusFor(store, now) {
    now = now || nowUTC8();
    var dayIdx = now.getDay();
    var mins = now.getHours() * 60 + now.getMinutes();
    var entry = dayEntryFor(store, dayIdx);

    if (entry && mins >= entry.open && mins < entry.close) {
      if (entry.lunch && mins >= entry.lunch[0] && mins < entry.lunch[1]) {
        return { state: 'lunch', label: ckT('ui.store.on_lunch', 'On lunch'),
          msg: ckT('ui.store.back_at', 'Back at {time}', { time: fmt(entry.lunch[1]) }) };
      }
      if (entry.close - mins <= 30) {
        return { state: 'soon', label: ckT('ui.store.closing_soon', 'Closing soon'),
          msg: ckT('ui.store.closes', 'Closes {time}', { time: fmt(entry.close) }) };
      }
      return { state: 'open', label: ckT('ui.store.open_now', 'Open now'),
        msg: ckT('ui.store.closes', 'Closes {time}', { time: fmt(entry.close) }) };
    }
    if (entry && mins < entry.open) {
      return { state: 'closed', label: ckT('ui.store.closed', 'Closed'),
        msg: ckT('ui.store.opens_today', 'Opens {time} today', { time: fmt(entry.open) }) };
    }
    // Closed today (or no entry today) — find the next open day.
    for (var i = 1; i <= 7; i++) {
      var d = (dayIdx + i) % 7;
      var ent = dayEntryFor(store, d);
      if (ent) {
        var msg = i === 1
          ? ckT('ui.store.opens_tomorrow', 'Opens tomorrow {time}', { time: fmt(ent.open) })
          : ckT('ui.store.opens_day', 'Opens {day} {time}', { day: DAY_LABEL[d], time: fmt(ent.open) });
        return { state: 'closed', label: ckT('ui.store.closed', 'Closed'), msg: msg };
      }
    }
    return { state: 'closed', label: ckT('ui.store.closed', 'Closed'), msg: '' };
  }

  function byId(id) {
    for (var i = 0; i < STORES.length; i++) if (STORES[i].id === id) return STORES[i];
    return null;
  }

  /* ---------- Top bar ---------- */
  var stat = document.getElementById('storeStat');
  var pop = document.getElementById('storePop');

  function renderBar() {
    if (!stat) return;
    var region = document.body.getAttribute('data-region') || 'sg';
    var inRegion = STORES.filter(function (s) { return s.country === region; });
    if (inRegion.length === 0) {
      stat.style.display = 'none';
      return;
    }
    stat.style.display = '';
    var main = inRegion.filter(function (s) { return s.main; })[0] || inRegion[0];
    var st = statusFor(main);

    var dot = stat.querySelector('.storestat__dot');
    var nameEl = stat.querySelector('.storestat__name');
    var msgEl = stat.querySelector('.storestat__msg');
    if (dot) dot.setAttribute('data-state', st.state);
    if (nameEl) nameEl.textContent = main.name;
    if (msgEl) msgEl.textContent = st.label + (st.msg ? ' · ' + st.msg : '');

    var moreBtn = stat.querySelector('.storestat__more');
    if (moreBtn) moreBtn.textContent = inRegion.length > 1
      ? ckT('ui.store.all_locations', 'All {count} locations', { count: inRegion.length })
      : ckT('ui.store.hours_map_html', 'Hours & map');

    if (pop) {
      var rows = inRegion.map(function (s) {
        var ss = statusFor(s);
        return '<a class="storerow" href="' + escapeHtml(localPath(s.href || '/pages/workshops')) + '">' +
          '<span class="storerow__dot" data-state="' + ss.state + '"></span>' +
          '<span class="storerow__info"><b>' + escapeHtml(s.name) +
            (s.main ? ' <i class="storerow__flag">' + escapeHtml(ckT('ui.store.main', 'Main')) + '</i>' : '') + '</b>' +
            '<span class="storerow__hours">' + escapeHtml(s.hours || '') + '</span></span>' +
          '<span class="storerow__stat" data-state="' + ss.state + '">' + escapeHtml(ss.label) +
            (ss.msg ? '<span class="storerow__sub">' + escapeHtml(ss.msg) + '</span>' : '') +
          '</span>' +
          '</a>';
      }).join('');
      var countryLabel = (inRegion[0] && inRegion[0].country_label) ||
        (region === 'my' ? ckT('ui.region.malaysia', 'Malaysia') : ckT('ui.region.singapore', 'Singapore'));
      pop.innerHTML = '<div class="storepop__inner">' +
        '<div class="storepop__head"><span>' + escapeHtml(countryLabel) +
        '</span><a href="' + escapeHtml(localPath('/pages/workshops')) + '">' +
        escapeHtml(ckT('ui.store.all_workshops', 'All workshops →')) + '</a></div>' +
        rows + '</div>';
    }
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;','\'':'&#39;' })[c];
    });
  }

  if (stat && pop) {
    var open = false;
    function setOpen(v) {
      open = v;
      pop.hidden = !v;
      stat.setAttribute('aria-expanded', v ? 'true' : 'false');
      stat.classList.toggle('is-open', v);
    }
    stat.addEventListener('click', function (e) { e.stopPropagation(); setOpen(!open); });
    document.addEventListener('click', function (e) { if (open && !pop.contains(e.target)) setOpen(false); });
    window.addEventListener('scroll', function () { if (open) setOpen(false); }, { passive: true });
  }

  /* ---------- Workshop page badges ---------- */
  function renderBadges() {
    document.querySelectorAll('.wsp-status[data-store]').forEach(function (b) {
      var s = byId(b.getAttribute('data-store'));
      if (!s) return;
      var ss = statusFor(s);
      b.setAttribute('data-state', ss.state);
      var l = b.querySelector('.wsp-status__label'); if (l) l.textContent = ss.label;
      var m = b.querySelector('.wsp-status__msg'); if (m) m.textContent = ss.msg;
    });
  }

  function renderAll() { renderBar(); renderBadges(); }
  renderAll();

  // Refresh every minute so status stays live.
  setInterval(renderAll, 60000);

  // Re-render when the region toggle changes data-region on <body>.
  if (window.MutationObserver) {
    new MutationObserver(renderBar)
      .observe(document.body, { attributes: true, attributeFilter: ['data-region'] });
  }
})();
